import { render, staticRenderFns } from "./AboutSwiper.vue?vue&type=template&id=30e21350&scoped=true&"
import script from "./AboutSwiper.vue?vue&type=script&lang=js&"
export * from "./AboutSwiper.vue?vue&type=script&lang=js&"
import style0 from "./AboutSwiper.vue?vue&type=style&index=0&id=30e21350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e21350",
  null
  
)

export default component.exports